import { render, staticRenderFns } from "./MdEdit.vue?vue&type=template&id=6635d282&"
import script from "./MdEdit.vue?vue&type=script&lang=js&"
export * from "./MdEdit.vue?vue&type=script&lang=js&"
import style0 from "./MdEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports